/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Error } from '../models/Error'
import type { ResponseParafkaOrderStatusList } from '../models/ResponseParafkaOrderStatusList'

import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'

export class ParafkaOrderService {
  /**
   * Zwraca statusy zleceń dla podanych ID
   * @returns ResponseParafkaOrderStatusList Lista statusów zleceń
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getOrderStatusFromParafka({
    orderIds,
    clientId,
  }: {
    /**
     * Lista ID zleceń
     */
    orderIds: string
    /**
     * identyfikator klienta
     */
    clientId: number
  }): CancelablePromise<ResponseParafkaOrderStatusList | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/parafka/order-status/{clientId}',
      path: {
        clientId: clientId,
      },
      query: {
        orderIds: orderIds,
      },
    })
  }
}
